import React from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexHowItWorksItem.scss';

const AmexHowItWorksItem = (
  {
    iconPathPrefix,
    icon,
    text,
    title,
  }
) => {
  const sanitizedTitle = sanitizeString(title);
  const sanitizedText = sanitizeString(text);
  return (
    <li className="AmexHowItWorksItem">
      <img
        className="AmexHowItWorksItem__img"
        src={`${iconPathPrefix}${icon}`}
        alt=""
      />
      <h3
        className="AmexHowItWorksItem__title"
        dangerouslySetInnerHTML={{
          __html: sanitizedTitle,
        }}
      />
      <p
        className="AmexHowItWorksItem__text"
        dangerouslySetInnerHTML={{
          __html: sanitizedText,
        }}
      />
    </li>
  );
};

AmexHowItWorksItem.propTypes = {
  iconPathPrefix: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default AmexHowItWorksItem;
